'use client';

import {
  ApiProjections,
  ICmsData,
  MyShop,
  MyShopStatusEnum,
  getMyShopSliceReq,
} from '@commerce-myshop-webcomponents/sdk';
import { ShopLanding } from '@commerce-myshop-webcomponents/ui';
import { ErrorCard, Errors, useSharecode } from '@commerce-webcomponents/ui';
import { useNextgenRouter } from '@nextgen-web-framework/all';
import { StorageService } from '@nextgen-web-framework/core';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../feature/store';
import styles from './MyShopReceiverPage.module.scss';
import Layout from 'app/components/Layout/Layout';
import { BasePageProps, LocalStorageKeys } from 'types/common';

export interface MyShopReceiverPageProps extends BasePageProps {
  myShopDetails: MyShop | null;
}

const MyShopReceiverPage = (props: MyShopReceiverPageProps) => {
  const router = useNextgenRouter();
  const { updateSharecode } = useSharecode();
  const shopCode = router.query?.get('shopCode');
  const sharecodeid = router?.query?.get('sharecodeid');
  const header = props.data?.layout?.header;
  const footer = props.data?.layout?.footer;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (typeof shopCode === 'string') {
      dispatch(
        getMyShopSliceReq({
          projections: ApiProjections.ALL,
          shopCodeUrl: decodeURIComponent(shopCode),
        }),
      );
    }
  }, [shopCode, router.params?.locale]);

  const { accountId, profileId } = useAppSelector((state) => state.commerceMyshop.shop);

  useEffect(() => {
    const hasSharecode = sharecodeid && typeof sharecodeid === 'string';
    if (!hasSharecode && accountId && profileId) {
      const shopAttributes = {
        accountId,
        profileId,
        category: 'myshop', // will use enum in subsequent PR
      };
      const localstorage = StorageService.getLocalStorage();
      updateSharecode(shopAttributes);
      localstorage.store(LocalStorageKeys.SHARECODE_ATTRIBUTES, shopAttributes);
    }
  }, [sharecodeid, accountId]);

  const onActionClick = () => {
    router.push('/');
  };
  const isReceiver = !!(props.myShopDetails?.shopId && props.myShopDetails?.status === MyShopStatusEnum.Active);

  return (
    <Layout
      hasTopMobileHeader={isReceiver}
      header={header}
      footer={footer}
      headerProps={{
        hasSearchBar: false,
        hasAmwayLogo: false,
      }}
    >
      <div data-testid="my-shop-receiver-container-testid">
        {isReceiver ? (
          <div className={styles['my-shop-receiver-container']}>
            <ShopLanding
              cmsData={props.data as ICmsData}
              isReceiver
              data={{
                ...props.myShopDetails,
              }}
              welcomeRedirect={onActionClick}
            />
          </div>
        ) : (
          <ErrorCard type={Errors.NotFound} onActionClick={onActionClick} />
        )}
      </div>
    </Layout>
  );
};

export default MyShopReceiverPage;
